export const MIN_TRADE_DURATION = 1;
